import React from "react";

class Works extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="portfolio" className="add-padding">
          <div className="container">
            <h1 className="big-text text-center scrollimation fade-in">
              My Work
              <br />
              <span className="text-dark h5">click to enlarge</span>
            </h1>
            <div className="row gallery-grid">
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairThree.jpg"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairThree.jpg"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>

              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairOne.JPEG"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairOne.JPEG"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairTwo.JPEG"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairTwo.JPEG"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairEight.jpg"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairEight.jpg"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
            </div>
            <div className="row gallery-grid">
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairFive.jpg"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairFive.jpg"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairSix.jpeg"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairSix.jpeg"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairSeven.jpg"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairSeven.jpg"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
              <div className="col-sm-3 col-md-3 p-0">
                <figure>
                  <div className="gallery-link">
                    <a
                      href="assets/images/hairNine.jpg"
                      className="icon icon-small bg-gray-dark rounded-circle text-white zoom"
                      target="_blank"
                    >
                      <i className="fa fa-scissors"></i>
                    </a>
                  </div>

                  <div className="gallery-img">
                    <img
                      src="assets/images/hairNine.jpg"
                      alt=""
                      className="img-fluid"
                    ></img>
                  </div>
                </figure>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default Works;
